import { SoundType } from '../types';

// Audio system
export const playSound = (type: SoundType) => {
  const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);

  switch(type) {
    case 'correct':
      oscillator.frequency.setValueAtTime(523.25, audioContext.currentTime); // C5
      oscillator.frequency.setValueAtTime(659.25, audioContext.currentTime + 0.1); // E5
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
      break;
    case 'wrong':
      oscillator.frequency.setValueAtTime(200, audioContext.currentTime);
      oscillator.frequency.setValueAtTime(150, audioContext.currentTime + 0.1);
      gainNode.gain.setValueAtTime(0.2, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.2);
      break;
    case 'levelUp':
      oscillator.frequency.setValueAtTime(400, audioContext.currentTime);
      oscillator.frequency.setValueAtTime(600, audioContext.currentTime + 0.1);
      oscillator.frequency.setValueAtTime(800, audioContext.currentTime + 0.2);
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
      break;
    case 'coin':
      oscillator.frequency.setValueAtTime(1046.50, audioContext.currentTime); // C6
      gainNode.gain.setValueAtTime(0.2, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.1);
      break;
    case 'gameOver':
      oscillator.frequency.setValueAtTime(300, audioContext.currentTime);
      oscillator.frequency.setValueAtTime(250, audioContext.currentTime + 0.1);
      oscillator.frequency.setValueAtTime(200, audioContext.currentTime + 0.2);
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.4);
      break;
  }

  oscillator.start(audioContext.currentTime);
  oscillator.stop(audioContext.currentTime + 0.5);
};

// JSON extraction from markdown
export const extractJSON = (text: string): string => {
  const trimmed = text.trim();
  const match = trimmed.match(/```(?:json)?\s*([\s\S]*?)```/);
  if (match) {
    return match[1].trim();
  }
  return trimmed;
};

// Environment detection
export const isProduction = (): boolean => {
  return window.location.hostname !== 'localhost' &&
         window.location.hostname !== '127.0.0.1' &&
         window.location.hostname !== '';
};

// Local storage helpers
export const storage = {
  getGameState: () => {
    try {
      const saved = localStorage.getItem('gameState');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  },

  setGameState: (state: any) => {
    try {
      localStorage.setItem('gameState', JSON.stringify(state));
    } catch (error) {
      console.error('Failed to save game state:', error);
    }
  }
};

// Random selection helper
export const getRandomItem = <T>(array: T[]): T => {
  return array[Math.floor(Math.random() * array.length)];
};

// Score calculation
export const calculateScore = (
  timeLeft: number,
  combo: number,
  config: { BASE_SCORE: number; TIME_BONUS_MULTIPLIER: number; COMBO_BONUS_MULTIPLIER: number }
): number => {
  const baseScore = config.BASE_SCORE;
  const timeBonus = Math.max(0, timeLeft * config.TIME_BONUS_MULTIPLIER);
  const comboBonus = combo * config.COMBO_BONUS_MULTIPLIER;
  return baseScore + timeBonus + comboBonus;
};

// Coin reward calculation
export const calculateCoins = (combo: number, threshold: number): number => {
  return combo >= threshold ? 2 : 1;
};

// Achievement validation
export const checkNewAchievements = (
  gameState: any,
  score: number,
  combo: number,
  achievements: string[]
): string[] => {
  const newAchievements = [];

  if (gameState.streak === 0 && gameState.totalScore === 0) {
    newAchievements.push('🌟 First Word!');
  }
  if (gameState.streak === 4) {
    newAchievements.push('🔥 5 Streak!');
  }
  if (combo >= 5) {
    newAchievements.push('⚡ Combo Master!');
  }
  if (gameState.totalScore + score >= 100 && !achievements.includes('💯 Century!')) {
    newAchievements.push('💯 Century!');
  }

  return newAchievements;
};